<hr class="dashed">
<div class="row">
    <div class="column">
        <mm-condensed-label-group id="wiresCondensed_transmissionNotes" [title]="transmissionNotesLabel" [data]="transmissionNotes"></mm-condensed-label-group>
    </div>  
</div>